module.exports = __webpack_public_path__ + "img/symbol_3.be94038a.png";